export const hideKitchener = true

export const cities = hideKitchener ? ["Toronto"] : ["Toronto", "Kitchener"]
